export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">关于我们</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            了解51动漫网的品牌故事与使命
          </p>
        </div>

        <div className="bg-background-50 rounded-lg border border-background-200/60 p-6 md:p-10">
          <div className="prose max-w-none">
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              51动漫网创立于对动漫文化的热爱与分享精神。作为一站式动漫在线阅读平台，我们致力于为全球华语动漫爱好者提供<strong>免费、便捷、高质量</strong>的动漫阅读服务。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              平台收录超过<strong>5000部</strong>日漫、国漫、韩漫作品，涵盖热血、恋爱、奇幻、悬疑、科幻、校园、治愈、异世界等全品类内容。每日同步更新超过<strong>100话</strong>，让读者第一时间追更心仪的作品。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-4">
              我们坚持<strong>免费开放、无需注册</strong>的原则，只为让更多人享受到动漫带来的快乐与感动。无论您是资深二次元爱好者，还是刚刚入坑的新读者，51动漫网都将是您最值得信赖的动漫阅读伙伴。
            </p>
            <p className="text-sm md:text-base text-foreground-700 leading-relaxed">
              未来，51动漫网将继续扩充内容库、优化阅读体验，为动漫爱好者打造更完善的在线阅读社区。感谢每一位读者的支持与陪伴。
            </p>
          </div>

          <div className="grid grid-cols-3 gap-4 mt-8 pt-6 border-t border-background-200/60">
            <div className="text-center">
              <div className="text-2xl font-heading font-bold text-primary-500">3+</div>
              <div className="text-xs text-foreground-500 mt-1">年稳定运营</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-heading font-bold text-accent-500">500万+</div>
              <div className="text-xs text-foreground-500 mt-1">月活跃读者</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-heading font-bold text-secondary-500">99.9%</div>
              <div className="text-xs text-foreground-500 mt-1">服务可用率</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}